export const formatDate = (dateString, fallbackText = 'Not Started') => {
  if (!dateString) return fallbackText;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallbackText;

  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
};


export const formatDateWithTime = (dateString, fallbackText = 'N/A') => {
  if (!dateString) return fallbackText;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallbackText;

  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });

  return `${month} ${day}, ${year}, ${time}`;
};
